import { capitalizeFirstLetter } from '../../helpers';
export var getNotificationTitle = function (title, type) {
    if (title)
        return title;
    if (type)
        return capitalizeFirstLetter(type === 'error' ? 'oops' : type);
    return 'Notification';
};
